import { Component, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { IdentityProvider } from '../../model/idp.modals';
import { IdpService } from 'src/app/services/identity-service/idp.service';
import { ToastrService } from 'ngx-toastr';
import * as Ladda from 'ladda';

@Component({
  selector: 'app-supported-identity-providers',
  templateUrl: './supported-identity-providers.component.html',
  styleUrls: ['./supported-identity-providers.component.css']
})
export class SupportedIdentityProvidersComponent implements OnInit {

  constructor(private modalService: BsModalService, private idpService: IdpService, private toastrService: ToastrService) { }
  model: IdentityProvider;
  modalRef: BsModalRef;
  serviceUrl = environment.serverUrl;
  saveButton: any;
  idpList: Array<IdentityProvider>;
  applicationIdp: Array<IdentityProvider>;
  ngOnInit() {
    this.populateJqGrid();
  }

  openIDPForm(idpTemplate: TemplateRef<any>) {
    this.model = new IdentityProvider();
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.modalRef = this.modalService.show(idpTemplate, config);
    this.saveButton = Ladda.create(document.querySelector('.btn-save'));
  }

  addIdp(idpForm: NgForm) {
    this.saveButton.start();
    this.saveButton.setProgress(0.5);
    this.model.createBy = localStorage.getItem('userId');
    this.model.createdOn = new Date();
    this.idpService.add(this.model).subscribe(
      (resp: any) => {
        debugger;
        if (!resp.error) {
          this.toastrService.success('Record saved successfully', 'Success')
          this.modalRef.hide();
          this.populateJqGrid();
          this.saveButton.stop();
        }
        else {
          this.toastrService.error(resp.statusText, 'Error')
          this.saveButton.stop();
        }
      }
    )
  }

  populateJqGrid() {
    var serviceURL = this.serviceUrl.concat('idp/get-all-idps');
    (<any>$("#jqGridIDPs")).jqGrid('GridUnload');
    (<any>$('#jqGridIDPs')).jqGrid({
      url: serviceURL,
      datatype: "json",
      height: 300,
      autowidth: true,
      shrinkToFit: true,

      rowNum: 100,
      rowList: [20, 40, 60, 100],
      toolbar: [false, "top"],
      colNames: ['Name', 'Status', 'Created On'],
      colModel: [
        { name: 'name', width: 153, index: 'name', sorttype: "string" },
        { name: 'active', width: 153, index: 'active', sorttype: "string", formatter: statusFormatter },
        { name: 'createdOn', index: 'createdOn', sorttype: "string", formatter: dateFormatter },

      ],
      pager: "#pager_list",
      viewrecords: true,
      emptyrecords: "No Records to Display",
      jsonReader: {
        root: "docs"
      },
    });

    function dateFormatter(cellvalue, options, rowObject) {

      let date = new Date(rowObject.createdOn);
      return date.toDateString() + date.toLocaleString([], { hour12: true }).split(',')[1];
    }
    function statusFormatter(cellvalue, options, rowObject) {
      if (rowObject.active)
        return '<span class="badge badge-success">Active</span>';
      else
        return '<span class="badge badge-danger">Inactive</span>';

    }
  }

}
